import React from 'react';
import Row from '@visa/vds/row';

const MCSSpace = (props) => {
    const DEFAULT_HEIGHT = "20px";
    let height = props.height ?? DEFAULT_HEIGHT;

    return (
        <Row style={{ height: height }}></Row>
    )
}

export default MCSSpace;